import { useAppSelector } from 'store'
import { selectName } from 'store/college'
import { isDemoCollegeNameAsScoirEnabled } from 'store/feature-toggle'

export default () => {
  const demoEnabled = useAppSelector(isDemoCollegeNameAsScoirEnabled)
  return demoEnabled ? 'Scoir University' : useAppSelector(selectName)
}
